import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SelectConfig } from '../../../model';

/**
 * * Componente de Inputs do tipo Select do Apolo.
 */
@Component({
  selector: 'ui-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class SelectComponent implements OnInit {

  /**
   * * Título para o componente.
   */
  @Input() title!: string;
  /**
   * * Name utilizado para os Inputs.
   */
  @Input() name: string = '';
  /**
   * * Valor Selecionado.
   */
  @Input() selectedValue: string = '';
  /**
   * * Placeholder exibido quando não existe valor selecionado.
   */
  @Input() placeholder: string = "Selecione uma Opção";
  /**
   * * Desabilitado.
   */
  @Input() disabled: boolean = false;
  /**
   * * Opções exibidas para o Select.
   */
  @Input() options: SelectConfig[] = [];

  /**
   * * Largura igual ao conteúdo.
   */
  @Input() widthFitContent: boolean = false;

  /**
   * * Evento de Seleção, retornando o valor selecionado.
   */
  @Output() emitter = new EventEmitter<string>();
  
  public open: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  emit(e: Event): void {
    if (e.target)
      this.emitter.emit((e.target as HTMLInputElement).value);
  }
}
